import { apiClient } from '../utils/apiClient';

class ApiRequestService {
  // Get all API requests (optionally filtered by collection)
  async getRequests(collectionId = null) {
    try {
      const params = collectionId ? { collection_id: collectionId } : {};
      const response = await apiClient.get('/api-requests', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch requests:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch requests');
    }
  }

  // Get a specific API request
  async getRequest(requestId) {
    try {
      const response = await apiClient.get(`/api-requests/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch request:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch request');
    }
  }

  // Create a new API request
  async createRequest(requestData) {
    try {
      const response = await apiClient.post('/api-requests', requestData);
      return response.data;
    } catch (error) {
      console.error('Failed to create request:', error);
      const err = new Error(
        error.response?.data?.error || error.response?.data?.message || 'Failed to create request'
      );
      // Preserve the Axios response so callers can detect plan-limit 402s
      // (error.response.data.upgrade_required) and open the upgrade modal.
      err.response = error.response;
      throw err;
    }
  }

  // Update an API request
  async updateRequest(requestId, requestData) {
    try {
      const response = await apiClient.put(`/api-requests/${requestId}`, requestData);
      return response.data;
    } catch (error) {
      console.error('Failed to update request:', error);
      throw new Error(error.response?.data?.message || 'Failed to update request');
    }
  }

  // Delete an API request
  async deleteRequest(requestId) {
    try {
      const response = await apiClient.delete(`/api-requests/${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete request:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete request');
    }
  }
}

export const apiRequestService = new ApiRequestService();
